// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"107cc930","84":"76b141b9"}[chunkId] + ".chunk.js";
};